import { MessagesButton } from '../engineer/MessagesButton'
import { PostcodePill } from '../engineer/PostcodePill'

/**
 * Shared engineer top-nav header (DEV-48214 §5.4). Mounted inside
 * `EngineerLayout` so it appears on every engineer route except JobSetup
 * (which sets `hideHeader` and is itself the postcode-entry page).
 *
 * Layout:
 *   [postcode pill]
 *   ─────────────────────────────────────────── (messages icon) ──
 *
 * The messages icon sits on the header's bottom edge, mostly inside the
 * header with under a third over the page, so it reads as a floating help
 * button without covering the search bar below.
 *
 * Colours come from `--nav-bg` / `--nav-text` CSS variables set by
 * `applyBrandColors()`. On a light default theme this reads as a light
 * header; on an admin-picked dark theme it flips automatically. The pill
 * and gauge both inherit `--nav-text` via `currentColor`.
 *
 * The tenant logo used to render on the left of this header, but it was
 * removed per client feedback (2026-07-15) — the shortcut icon on the
 * home screen already carries the brand, and duplicating it in the header
 * left the postcode pill visually crowded.
 */
export function EngineerHeader() {
  return (
    <header className="sticky top-0 z-30 bg-nav text-nav border-b border-nav-divider">
      <div className="relative max-w-3xl mx-auto px-5 py-3 flex items-center justify-between gap-3">
        {/* min-h-11 reserves the pill's height: the pill renders nothing until
            it has read the postcode, and the messages icon is positioned
            absolutely, so without it the header would collapse and jump. */}
        <div className="flex items-center gap-3 min-w-0 min-h-11">
          <PostcodePill />
        </div>
        <div className="absolute right-5 bottom-0 translate-y-[30%]">
          <MessagesButton />
        </div>
      </div>
    </header>
  )
}
